import { EActionType, IActionType, IGlobleState } from "./types";

const defaultState: IGlobleState = {
  loading: false,
  userInfo: {
    account: "",
    email: "",
    name: "",
    workcode: "",
    teacher_id: null,
    teacher_type: 0,
  },
  routes: [],
  noAuthority: true,
};

const reducer = (
  state: IGlobleState = defaultState,
  action: IActionType
): IGlobleState => {
  switch (action.type) {
    case EActionType.LOADING:
      return { ...state, loading: action.loading! };
    case EActionType.SET_ROUTES:
      return { ...state, routes: action.routes! };
    case EActionType.USERINFO:
      return { ...state, userInfo: action.userInfo! };
    case EActionType.NO_AUTHORITY:
      return { ...state, noAuthority: action.noAuthority! };
    default:
      return state;
  }
};

export default reducer;
